import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "src/pages/Login/Login.vue")
  },
  {
    path: "/oauth/:provider/login",
    name: "SocialLogin",
    component: () =>
      import(/* webpackChunkName: "login" */ "src/pages/SocialLogin/SocialLogin.vue")
  },
  {
    path: "/reset-password",
    component: () =>
      import(/* webpackChunkName: "reset-password" */ "src/pages/ResetPassword/ResetPassword.vue"),
    children: [
      {
        path: "",
        name: "ResetPasswordForm",
        component: () =>
          import(/* webpackChunkName: "reset-password-form" */ "src/pages/ResetPassword/ResetPasswordForm.vue")
      },
      {
        path: "success",
        name: "ResetPasswordSuccess",
        component: () =>
          import(/* webpackChunkName: "reset-password-success" */ "src/pages/ResetPassword/ResetPasswordSuccess.vue")
      },
      {
        path: "error",
        name: "ResetPasswordError",
        component: () =>
          import(/* webpackChunkName: "reset-password-error" */ "src/pages/ResetPassword/ResetPasswordError.vue")
      }
    ]
  },
  {
    path: "/verify",
    component: () =>
      import(/* webpackChunkName: "strong-password" */ "src/pages/StrongPassword/StrongPassword.vue"),
    children: [
      {
        path: "",
        name: "StrongPasswordForm",
        component: () =>
          import(/* webpackChunkName: "strong-password-form" */ "src/pages/StrongPassword/StrongPasswordForm.vue")
      },
      {
        path: "success",
        name: "StrongPasswordSuccess",
        component: () =>
          import(/* webpackChunkName: "strong-password-success" */ "src/pages/StrongPassword/StrongPasswordSuccess.vue")
      },
      {
        path: "error",
        name: "StrongPasswordError",
        component: () =>
          import(/* webpackChunkName: "strong-password-error" */ "src/pages/StrongPassword/StrongPasswordError.vue")
      }
    ]
  },
  {
    path: "/integration/consent",
    name: "IntegrationConsent",
    component: () =>
      import(/* webpackChunkName: "integration-consent" */ "src/pages/IntegrationConsent/IntegrationConsent.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    name: "Error404",
    redirect: { name: "Login" }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
